import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { typePageSearchSchema } from '#/components/ontology/search'
import { TypePage } from '#/components/ontology/type-page'
import { useOntologyExplorer } from '#/components/ontology/use-ontology-explorer'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/ontology/types/$typeName',
)({
  validateSearch: typePageSearchSchema,
  component: NodeTypeRoute,
})

function NodeTypeRoute() {
  const { t } = useTranslation()
  const { typeName } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { doc } = useOntologyExplorer()
  const type = doc.node_types.find((nt) => nt.name === typeName)

  if (!type) {
    return (
      <p className="p-8 text-sm text-muted-foreground">
        {t('ontology.typeNotFound')}
      </p>
    )
  }

  return (
    <TypePage
      doc={doc}
      type={type}
      tab={tab ?? 'properties'}
      onTabChange={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            tab: next === 'properties' ? undefined : next,
          }),
          replace: true,
        })
      }}
    />
  )
}
